import React, { useEffect, useState, useRef } from "react";
import MetaTags from "react-meta-tags";

const AcademiaConfiguracion = () => {

    return (<>Academia Configuracion</>)
}

export default AcademiaConfiguracion;